export enum CourseStatus {

    D,
    P,
    W

}